/**
 * Работы цикла по источнику — план · предписания · добровольные отдельными
 * строками (design §7.1 п. 6, ось `source` слоя метрик). Числа — ответ
 * `GET /agrocycles` (`sources`), клиент не складывает и не сравнивает:
 * добровольные стоят без доли выполнения и без ранжирования (№794).
 */

import { defineMessages } from '../../../i18n/define';
import type { PlainMessage } from '../../../i18n/define';
import { useT } from '../../../i18n/hooks';
import type { Source } from './agrocycleApi';
import { sourceLine } from './agrocycleView';
import './agrocycle.css';

const m = defineMessages({
  label: {
    id: 'cycle.sources.label',
    defaultMessage: 'Работы агроцикла по источнику',
    description: 'aria-label списка источников работ агроцикла (план, предписания, добровольные); читают программы экрана',
  },
  notePlan: {
    id: 'cycle.sources.note.plan',
    defaultMessage: 'работы на полях запущенных кампаний плана — знаменатель «Выполнено»',
    description: 'Пояснение под строкой «План» в списке источников работ (хоким, менеджер); «Выполнено» — название KPI',
  },
  notePrescription: {
    id: 'cycle.sources.note.prescription',
    defaultMessage: 'свой счёт: в % выполнения плана не входят',
    description: 'Пояснение под строкой «Предписания» (карантин) в списке источников работ',
  },
  labelPlan: { id: 'cycle.sources.label.plan', defaultMessage: 'По плану агроцикла', description: 'Строка источника работ: работы запущенных кампаний плана агроцикла; заголовок строки, коротко' },
  labelPrescription: { id: 'cycle.sources.label.prescription', defaultMessage: 'По предписаниям карантина', description: 'Строка источника работ: работы по карантинным предписаниям; заголовок строки, коротко' },
  labelVoluntary: { id: 'cycle.sources.label.voluntary', defaultMessage: 'Добровольные работы хозяйств', description: 'Строка источника работ: добровольные работы хозяйств (вне % выполнения); заголовок строки, коротко' },
  noteVoluntary: {
    id: 'cycle.sources.note.voluntary',
    defaultMessage: 'учёт хозяйства, не обязательства: долей и сравнения нет',
    description: 'Пояснение под строкой «Добровольные работы» в списке источников работ',
  },
});

const LABEL: Record<Source['source'], PlainMessage> = {
  plan: m.labelPlan,
  prescription: m.labelPrescription,
  voluntary: m.labelVoluntary,
};

const NOTE: Record<Source['source'], PlainMessage> = {
  plan: m.notePlan,
  prescription: m.notePrescription,
  voluntary: m.noteVoluntary,
};

export function CycleSources({ sources, compact = false }: { sources: ReadonlyArray<Source>; compact?: boolean }) {
  const t = useT();
  if (!sources.length) return null;
  return (
    <ul className={`agc-sources${compact ? ' agc-sources--compact' : ''}`} aria-label={t(m.label)}>
      {sources.map((row) => (
        <li key={row.source} className="agc-source" data-source={row.source}>
          <span className="agc-source__label">{LABEL[row.source] ? t(LABEL[row.source]) : row.label}</span>
          <span className="agc-source__value">{sourceLine(row)}</span>
          {compact ? null : <span className="agc-muted">{t(NOTE[row.source])}</span>}
        </li>
      ))}
    </ul>
  );
}
